// src/hooks/useMessages.js
import { useEffect, useState } from "react";

import { fetchMessages } from "../../api/api";
import { useMessageContext } from "../context/MessageContext";

export const useMessages = (topicId) => {
  const { state, dispatch } = useMessageContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // On mount, fetch the messages
  useEffect(() => {
    if (!topicId || state[topicId]) {
      // Skip fetching if topicId is missing or messages already exist
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchMessages(topicId)
      .then((messages) => {
        dispatch({ type: "SET_MESSAGES", topicId, messages });
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [topicId, dispatch, state[topicId]]);

  return {
    messages: state[topicId] || [],
    loading,
    error,
  };
};
